export default __webpack_public_path__ + "static/media/screens.7adeac38.png";